import { render } from "./OrdersMangerBigud.vue?vue&type=template&id=510340af&scoped=true"
import script from "./OrdersMangerBigud.vue?vue&type=script&lang=js"
export * from "./OrdersMangerBigud.vue?vue&type=script&lang=js"

import "./OrdersMangerBigud.vue?vue&type=style&index=0&id=510340af&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510340af"]])

export default __exports__